import React from 'react';
import { compose } from 'redux';
import { useTranslation } from 'react-i18next';
import { URLS } from '@wix/da-url';
import Button from '../../../Button';
import AddIcon from '@wix/da-ds/pkg/Icons/24x24/Add';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import withCurrentGallection from '../../_hocs/withCurrentGallection';
const enhance = compose(withCurrentGallection);
export const SubmitDeviationsButton = ({ buttonView, plusOnly, currentFolderId })=>{
    const { t } = useTranslation();
    return plusOnly ? /*#__PURE__*/ React.createElement(Button, {
        view: 'b3',
        href: `${URLS.SUBMIT}?folderid=${currentFolderId}`
    }, /*#__PURE__*/ React.createElement(AddIcon, null)) : /*#__PURE__*/ React.createElement(GhostButton, {
        variant: "main",
        size: "large",
        href: `${URLS.SUBMIT}?folderid=${currentFolderId}`,
        icon: AddIcon
    }, t('mediapopup.submitDeviations'));
};
SubmitDeviationsButton.displayName = 'SubmitDeviationsButton';
export default enhance(SubmitDeviationsButton);
